export default __webpack_public_path__ + "static/media/1982.27990713.png";